import React from 'react';
import { Modal, Card } from 'antd';

interface IComponentProps {
	data?: any;
  visible?: any;
  onCancel?: any;
}

const RemarkDetail:React.FC<any> = (props) => {

  const { visible, onCancel, policy } = props || {};

  const handleCancel = () => {
    onCancel && onCancel();
  };
  
  return (
    <Modal
      width={800}
      title="服务政策"
      open={visible}
      okText="关闭"
      onOk={handleCancel}
      onCancel={handleCancel}
      cancelButtonProps={{style: { display: 'none' }}}
      okButtonProps={{ disabled: false }}
    >
      {Object.keys(policy || {}).map((item: string) => {
        return (
          <Card size ="small" title={item} style={{ marginBottom: 12 }}>
            <div>{policy[item]}</div>
          </Card>
        )
      })}
    </Modal>
  );
}

export default RemarkDetail;